{
  "auth.email_signup.email.label": "Correo electrónico",
  "auth.email_signup.first_name_caption": "Puedes agregar un nombre preferido en tu Cuenta más adelante.",
  "auth.email_signup.first_name_on_driver_license.label": "Nombre en la licencia de conducir",
  "auth.email_signup.firstname.required": "El nombre es obligatorio",
  "auth.email_signup.last_name_on_driver_license.label": "Apellido en la licencia de conducir",
  "auth.email_signup.lastname.required": "El apellido es obligatorio",
  "auth.email_signup.marketing.label": "Envíame promociones y anuncios por correo electrónico",
  "auth.email_signup.marketing.optin_matrix_label": "Envíame actualizaciones, recomendaciones y ofertas por correo electrónico",
  "auth.email_signup.sms_marketing.label": "Envíame promociones y anuncios por SMS",
  "auth.email_signup.or_sign_up_with_others": "O regístrate con {#facebookLink}Facebook{/facebookLink} o {#googleLink}Google{/googleLink}",
  "auth.email_signup.password.error_min_length": "La contraseña debe tener al menos 8 caracteres",
  "auth.email_signup.email.error_format": "Ingresa un correo electrónico válido",
  "auth.email_signup.password.label": "Contraseña",
  "auth.email_signup.sign_up": "Registrarse",
  "auth.email_signup.terms_of_service.label": "Acepto las {#termsOfServiceLink}condiciones del servicio{/termsOfServiceLink} y la {#privacyPolicyLink}política de privacidad{/privacyPolicyLink}.",
  "auth.email_signup.title": "Comencemos"
}
